<script setup lang="ts">
import { onMounted, ref } from "vue";
import { RouterLink, useRoute, useRouter } from "vue-router";

import SkoreSpinner from "@/components/ui/SkoreSpinner.vue";
import FullPageCenteredLayout from "@/layouts/FullPageCenteredLayout.vue";
import { RouteNames } from "@/router";
import { useApi } from "@/services/api";

const route = useRoute();
const router = useRouter();
const api = useApi();
const hasError = ref(false);

onMounted(() => {
  const { access_token, refresh_token, expires_at } = route.query;
  if (access_token && refresh_token && expires_at) {
    // save the tokens
    api.markAuthenticated(expires_at as string);
    router.replace({ name: RouteNames.Dispatch });
  } else {
    hasError.value = true;
  }
});
</script>

<template>
  <FullPageCenteredLayout>
    <main class="login-success">
      <div class="error" v-if="hasError">
        <div class="message">Something went wrong, please try again.</div>
        <div class="link">
          <RouterLink :to="{ name: RouteNames.Login }">login</RouterLink>
        </div>
      </div>
      <SkoreSpinner v-else />
    </main>
  </FullPageCenteredLayout>
</template>

<style scoped>
.login-success {
  .error {
    .message {
      color: var(--color-text-danger);
    }

    .link {
      a {
        color: var(--color-text-primary);
      }
    }
  }
}
</style>
